export enum FILE_TYPE {
  IMAGE = 'image',
  VIDEO = 'video',
}
